import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen therapy-bg">
      {/* Hero Section with Background Image */}
      <section 
        className="landing-hero min-h-screen flex items-center justify-center px-4 py-12 relative"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_fcb6d1ec-c022-4ff6-b8db-4a4682b53fb2/artifacts/5ih7ut2f_beta.iam-buddy.com.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-black/50"></div>
        
        {/* Content */}
        <div className="max-w-md mx-auto text-center space-y-8 animate-fade-in relative z-10">
          {/* Logo/Brand */}
          <div className="space-y-3">
            <h1 
              className="text-4xl md:text-5xl font-bold tracking-tight text-white drop-shadow-lg"
              data-testid="landing-title"
            >
              i am buddy
            </h1>
            <p className="text-lg text-white/90 leading-relaxed max-w-sm mx-auto drop-shadow-md">
              Your companion for recovery. Not just an app, a buddy who's with you every step of the journey.
            </p>
          </div>

          {/* Value Proposition */}
          <div className="space-y-4 text-left bg-[#2D3640]/90 backdrop-blur-md rounded-2xl p-6 border border-[#4A5568] shadow-2xl">
            <h2 className="text-xl font-semibold text-white">
              Your journey to recovery
            </h2>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start gap-3">
                <svg className="w-6 h-6 text-[#2DD4BF] flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Building capacity, not counting days</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-6 h-6 text-[#2DD4BF] flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Evidence-based support without shame</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-6 h-6 text-[#2DD4BF] flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Your buddy in building a meaningful life</span>
              </li>
            </ul>
          </div>

          {/* CTA Buttons */}
          <div className="space-y-4 pt-4">
            <Button
              onClick={() => navigate('/signup')}
              className="button-primary w-full rounded-full px-8 py-6 h-auto text-lg font-medium text-white shadow-xl"
              data-testid="get-started-btn"
            >
              Get Started
            </Button>
            <Button
              onClick={() => navigate('/login')}
              variant="ghost"
              className="w-full rounded-full px-8 py-4 h-auto text-lg font-medium text-white/80 hover:bg-white/10 hover:text-white"
              data-testid="login-link-btn"
            >
              Already have an account? Log in
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
